import BackToTopAPI from './back-top-top-api';

export default BackToTopAPI;
